import React from "react";

const PurchaseCoinPlan = (props) => {

  const getSource = (data) => {
    if (data.source === "APP_PURCHASE" && data.paymentGateway) {
      return data.paymentGateway;
    }
    if (data.sourceLabel) return data.sourceLabel;

    const type = data.type;
    switch (type) {
      case 2:
        return "App Purchase";
      case 12:
        return "Diamond Seller";
      case 19:
        return "Admin Send";
      default:
        return "Unknown";
    }
  };
  return (
    <table className="table table-striped mt-5">
      <thead>
        <tr>
          <th>No.</th>
          <th>User Name</th>
          <th>Diamond</th>
          <th>Dollar</th>
          <th>PHP</th>
          <th>Source</th>
          <th>Status</th>
          <th>Purchase Date</th>
        </tr>
      </thead>
      <tbody>
        {props.data?.length > 0 ? (
          props.data.map((data, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data.name}</td>
                <td className="text-primary">{data.diamond}</td>
                <td className="text-info">{data.dollar ?? "-"}</td>
                <td className="text-success">{data.php ?? "-"}</td>
                <td className="text-danger">{getSource(data)}</td>
                <td>{data.status || "-"}</td>
                <td>{new Date(data.purchaseDate).toLocaleString()}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="8" align="center">
              Nothing to show!!
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PurchaseCoinPlan;
